import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateTemplatePayload, NotificationTemplate, UpdateTemplatePayload } from '../../models/notification-template';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class NotificationTemplatesService {
  private baseUrl = `${environment.url}/customer-notifications/templates`;
  private http = inject(HttpClient);

  getTemplates(): Observable<ApiResponse<NotificationTemplate[]>> {
    return this.http.get<ApiResponse<NotificationTemplate[]>>(this.baseUrl);
  }

  createTemplate(payload: CreateTemplatePayload): Observable<ApiResponse<NotificationTemplate>> {
    return this.http.post<ApiResponse<NotificationTemplate>>(this.baseUrl, payload);
  }

  updateTemplate(id: number, payload: UpdateTemplatePayload): Observable<ApiResponse<NotificationTemplate>> {
    return this.http.patch<ApiResponse<NotificationTemplate>>(`${this.baseUrl}/${id}`, payload);
  }

  deleteTemplate(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
